// extracted by mini-css-extract-plugin
export default {"wrapper":"axisdropdown_wrapper__qUuP+","btnDropdown":"axisdropdown_btnDropdown__XPxuY"};